module.exports = __webpack_public_path__ + "static/media/pbtcEPS.474d84c1.png";